"use client";

import { useEffect, useState } from "react";
import TimelineView from "@/components/timeline/TimelineView";
import { getTimeline } from "@/lib/api";
import type { TimelineData } from "@/lib/types";
import { Loader2 } from "lucide-react";

export default function TimelinePage() {
  const [data, setData] = useState<TimelineData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [zoom, setZoom] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getTimeline()
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) {
    return (
      <div
        className="flex items-center justify-center"
        style={{ height: "calc(100vh - 64px)", background: "#0a0e1a" }}
      >
        <div className="text-center">
          <p style={{ color: "#e8e0d0" }} className="text-lg mb-2">
            Failed to load timeline
          </p>
          <p style={{ color: "rgba(232, 224, 208, 0.5)" }} className="text-sm">
            {error}
          </p>
        </div>
      </div>
    );
  }

  if (loading || !data) {
    return (
      <div
        className="flex items-center justify-center"
        style={{ height: "calc(100vh - 64px)", background: "#0a0e1a" }}
      >
        <div className="flex items-center gap-3">
          <Loader2
            size={20}
            className="animate-spin"
            style={{ color: "#c8a45e" }}
          />
          <span style={{ color: "#e8e0d0" }} className="text-sm">
            Loading timeline...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ height: "calc(100vh - 64px)" }}>
      <TimelineView
        data={data}
        zoom={zoom}
        onZoomChange={setZoom}
        searchQuery={searchQuery}
        onSearch={setSearchQuery}
      />
    </div>
  );
}
